// AI-content disclaimer for Featured guides (4.10.55, user OK 2026-10-27).
// Same wording as the website's city pages and Destinations page. Shown at
// the top of the Library's Featured list and in the "Make a copy" confirm
// when the guide being copied is Featured. Same file in mobile.

export const AI_DISCLAIMER =
  "Guides are made with the help of AI and public sources such as Wikipedia, and may contain errors. Opening hours and prices change, so check before you go.";
// 2026-11-03: the link used to open the Partner Offers page (Docs/Tickets.html). It now opens an e-mail in the
// website's report format (scripts/city-pages/report_link.py): a "[Andiamo report]" subject to filter on and
// labelled lines a script can read.
export const AI_DISCLAIMER_LINK_TEXT =
  "Spotted a wrong photo, a pin in the wrong place or a missing stop, or missing a destination? Write to andiamotravelapp@gmail.com.";
const REPORT_FIELDS = [
  "Kind (wrong photo, wrong location, missing place, wrong fact or hours, better stop, missing destination, other)",
  "Guide or destination",
  "Stop or day",
  "What should change",
  "Your name (optional)",
];

// 2026-11-03: the e-mail also asks for photos (same words as the website's report_link.py)
export const PHOTO_LINE =
  "Got a better photo? Send it to us! Attach it to this e-mail and tell us which stop it shows. By sending it you agree that we may use it in the guide, with your name as the credit.";

// mailto with the subject "[Andiamo report] <about>[ | <guide id>]" and one "Label: " line per field.
export function reportMailto(about, guideId = null, guideName = null) {
  const subject = `[Andiamo report] ${about}${guideId ? ` | ${guideId}` : ""}`;
  const lines = [...(guideId ? [`Guide: ${guideName || about} (${guideId})`] : []), ...REPORT_FIELDS.map((f) => `${f}: `), "", PHOTO_LINE];
  return `mailto:andiamotravelapp@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join("\n") + "\n")}`;
}

export const FEEDBACK_URL = reportMailto("Featured guides");

const COPY_CONFIRM =
  "Make a copy of this Guide? This will make a copy of the guide, and open the copy. First save any changes that you want in the original copy.";

export const isFeaturedGuide = (attributes) => attributes?.type === "Featured";

// The text for the "Make a copy" confirm (mobile passes its shorter wording):
// the disclaimer is added for a Featured guide.
export function copyConfirmText(attributes, message = COPY_CONFIRM) {
  return isFeaturedGuide(attributes) ? `${message}\n\n${AI_DISCLAIMER}` : message;
}
